const initialState = {
    tags: [],
};
export const tagsReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'GET_TAGS':
            return {
                ...state,
                tags: action.payload,
                loading: action.loading ?? false
            }
        default:
            return state
    }
}
